import LibraryIcon_vue_vue_type_script_setup_true_lang_default from "./LibraryIcon.vue.script.js";
//#region src/library/LibraryIcon.vue
var LibraryIcon_default = LibraryIcon_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { LibraryIcon_default as default };

//# sourceMappingURL=LibraryIcon.vue.js.map